import QuoteDisplay from './QuoteDisplay';
export default QuoteDisplay;
